import { useContext, useState } from "react";
import OutsetaApiClient from "outseta-api-client";

import Button from "components/Button";
import possessiveString from "helpers/possessiveString";

import IconCheck from "assets/svgs/checkmark.svg";
import IconPlus from "assets/svgs/plus.svg";

import { OutsetaContext } from "pages/_app";

import useAnalytics from "hooks/useAnalytics";

const client = new OutsetaApiClient({
  subdomain: "uncovered",
  apiKey: "f7b76fc3-bf73-4278-ba64-93ad63d35b7c",
  secretKey: "8aaea30db3e3f3ae7774852791e94c0b",
});

function arrayRemove(arr, value) {
  return arr.filter(function (ele) {
    return ele !== value;
  });
}

export default function FollowCase({
  buttonHeight,
  outsetaUserId,
  outsetaUserCaseList,
  classes,
  customFirstName,
  slug,
}) {
  const [localOutsetaCaseList, setLocalOutsetaCaseList] = useState([]);
  const { addOutsetaUserCaseList } = useContext(OutsetaContext);
  const { track } = useAnalytics();

  const updateFollowing = () => {
    let tempArray;
    if (outsetaUserCaseList !== undefined) {
      tempArray = outsetaUserCaseList.split(",");
    } else {
      tempArray = [];
    }
    const includesSlug = tempArray.includes(slug);
    includesSlug
      ? (tempArray = arrayRemove(tempArray, slug))
      : tempArray.push(slug);
    setLocalOutsetaCaseList(tempArray);
    addOutsetaUserCaseList(tempArray.join(","));
    client.crm.people.update({
      Uid: outsetaUserId,
      CaseList: tempArray.join(","),
    });
    if (includesSlug) {
      track("case_unfollowed", { slug: slug });
    }
    else {
      track("case_followed", { slug: slug });
    }
    
  };

  return (
    <>
      {/* need to work out this scenario for unfollowing */}
      {/* This should be refactored to not dupe all the button styles */}
      {(outsetaUserCaseList && outsetaUserCaseList.includes(slug)) ||
      (localOutsetaCaseList && localOutsetaCaseList.includes(slug)) ? (
        <Button
          id="follow-case-btn"
          className={`text-sm ${classes === null ? "w-full" : classes}`}
          emphasis="secondary"
          height={buttonHeight || "40"}
          onClick={() => {
            updateFollowing();
          }}
        >
          <IconCheck className="mr-2" width="15" />
          Following
        </Button>
      ) : (
        <Button
          id="follow-case-btn"
          emphasis="primary"
          height="32"
          onClick={() => {
            updateFollowing();
          }}
        >
          <IconPlus className="mr-1" width="8" /> Follow{" "}
          {possessiveString(customFirstName)} Case
        </Button>
      )}
    </>
  );
}
